<template>
  <Modal
    :modalType="modalType"
    mayCancel="true"
    v-on:cancel="onDone"
    width="auto"
    anchorStyle="topAuto"
    :anchorRect="anchorRect"
  >
    <div
      class="Wrapper"
      v-for="colorSection in colorSections"
      :key="colorSection[0]"
    >
      <p v-if="colorSection[0]">{{ colorSection[0] }}:</p>
      <div class="ColorCollection">
        <div
          :class="getColorBoxCSSClass(color)"
          v-for="color in colorSection[1]"
          v-bind:key="color"
          v-bind:style="getStyle(color)"
          v-on:click="apply(color)"
        ></div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import tinycolor from "tinycolor2";
import { ModalType } from "@/store/ModalType";
import Rect from "@/wbcontroller/types/Rect";
import WBComponent from "@/WBComponent";
import { ModalMutations } from "@/store/modules/modal";
import { CSSProperties } from "vue/types/jsx";

@Component({ components: { Modal } })
export default class ColorPickerModal extends WBComponent {
  @Prop(String) readonly setterKey!: string | undefined;
  @Prop() readonly modalType!: ModalType;

  get anchorRect(): Rect | undefined {
    return this.state.modal.modalAnchors[this.modalType];
  }

  get colorSections(): [string, string[]][] {
    if (this.state.toolConfig.customColors) {
      return this.state.toolConfig.customColors;
    } else if (this.setterKey === "setFillColorForSticky") {
      return [["", this.artisanalColors]];
    } else {
      return [
        ["Locally-sourced, artisanal colors", this.artisanalColors],
        ["Mass-produced, non-organic colors", this.factoryColors],
      ];
    }
  }

  get artisanalColors(): string[] {
    if (this.setterKey === "setFillColorForSticky") {
      return this.state.toolConfig.colors.artisanal;
    } else {
      return new Array<string>()
        .concat(this.state.toolConfig.colors.util)
        .concat(this.state.toolConfig.colors.artisanal);
    }
  }

  get factoryColors(): string[] {
    const factoryColors = this.state.toolConfig.colors.factory;
    if (!factoryColors.length) return [];
    const rowOrderColors = new Array<string>();
    for (let col = 0; col < factoryColors.length; col++) {
      for (let row = 0; row < factoryColors[0].length; row++) {
        rowOrderColors.push(factoryColors[col][row]);
      }
    }
    return rowOrderColors;
  }

  getStyle(color: string): CSSProperties {
    if (tinycolor(color).getAlpha() < 1) {
      return { backgroundImage: 'url("/img/checkerboard.png"' };
    } else {
      return { backgroundColor: color };
    }
  }

  getColorBoxCSSClass(color: string): string {
    if (tinycolor(color).isLight() || tinycolor(color).getAlpha() < 1) {
      return "ColorBox m-light";
    } else {
      return "ColorBox m-dark";
    }
  }

  apply(color: string) {
    this.$store.commit(this.setterKey || "setStrokeColor", color);
    this.onDone();
  }

  onDone() {
    ModalMutations.closeModals(this.$store.commit);
    this.$emit("done");
  }
}
</script>

<style lang="scss">
.Modal p:first-child {
  margin-top: 0;
}

.ColorCollection {
  display: grid;
  row-gap: 1px;
  column-gap: 1px;

  grid-template-columns: 30px 30px 30px 30px 30px 30px 30px 30px 30px;
  grid-auto-rows: 30px;
}

.Wrapper:first-child > p:first-child {
  margin-top: 0;
}

.ColorBox {
  cursor: pointer;

  &.m-light:hover {
    border: 1px solid black;
  }

  &.m-dark:hover {
    border: 1px solid white;
  }
}
</style>
